import { debounceRAF } from "../utils/timing";

export class ScrollNavBar {

    constructor() {

        this.navAlt = false;

        this.updateAlt(true);
        window.addEventListener('scroll', debounceRAF(() => this.updateAlt()));

    }

    updateAlt(init) {

        if ((!this.navAlt || init) && window.scrollY > 100) {

            document.body.classList.add('nav-alt');

            this.navAlt = true;

        } else if ((this.navAlt || init) && window.scrollY <= 100) {

            document.body.classList.remove('nav-alt');

            this.navAlt = false;

        }

    }

}
